import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getToken } from '../utils/cookies';

const AuthRoute = ({
  children,
  type = 'protected',
  redirectTo = '/login'
}) => {
  const hasCookieToken = getToken();

  const isAuthenticatedUser =  hasCookieToken;

  if (type === 'protected') {
    return isAuthenticatedUser ? children : <Navigate to={redirectTo} replace />;
  } else {
    return isAuthenticatedUser ? <Navigate to="/dashboard" replace /> : children;
  }
};

export default AuthRoute; 